import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { selectedNodeSelector } from '@cbridge-packages/node';
import { StreamAction } from '../stream.action';

type IState =
  & IGetSelectorStateType<typeof selectedNodeSelector>;

export const reloadStreamListEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOf(
    StreamAction.reload,
    StreamAction.create.done,
    StreamAction.update.done,
  ),
  withLatestFrom(state$),
  mergeMap(([, state]) => {
    const selectedNode = selectedNodeSelector(state);

    return [
      StreamAction.loadList.started({ nodeId: selectedNode }),
    ];
  }),
);
